module.exports = __webpack_public_path__ + "img/niu4.4bb8b315.jpg";